import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_142: FaireProductEntity = {
  token: "legacy_prod_abbott-142",
  type: "product",
  name: "Candy Cane Room Spray-100ml",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0ee0c20430399b6a1f6e34d88f194ebd52982b53f9ccfa0a66cd580e4f7e94f9.jpeg",
  priceDollars: 14,
  subcategory: "Room Sprays",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-fragrances"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
